import { PalTextField, PalTypography } from "@palamar/fe-library";

import { Grid } from "@mui/material";

import { RequiredComp, StepContainer } from "../CommonComponents";

function StepBotSettings({ formik, stepKey, setFieldValue }) {
  return (
    <StepContainer>
      <Grid container spacing={2}>
        <Grid item mb={2} xs={12}>
          <PalTypography color="textPrimary" fontWeight={600} variant="h5">
            Bot Settings
          </PalTypography>
          <PalTypography gutterBottom variant="body1">
            Please enter the AI assistant's name and customize the assistant's prompt.
          </PalTypography>
        </Grid>
        <Grid item xs={12}>
          <PalTypography gutterBottom fontWeight={600} variant="body1">
            Assistant Name
            <RequiredComp />
          </PalTypography>
          <PalTextField
            fullWidth
            invalid={formik.touched[stepKey]?.bot_name && formik.errors[stepKey]?.bot_name}
            name={`${stepKey}.bot_name`}
            placeholder="Enter Assistant Name"
            value={formik.values[stepKey].bot_name}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <PalTypography gutterBottom fontWeight={600} variant="body1">
            Define main goals
          </PalTypography>
          <PalTextField
            fullWidth
            multiline
            invalid={formik.touched[stepKey]?.awareness_prompt && formik.errors[stepKey]?.awareness_prompt}
            maxRows={9}
            minRows={5}
            name={`${stepKey}.awareness_prompt`}
            placeholder="Enter main goals"
            value={formik.values[stepKey].awareness_prompt}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
          />
        </Grid>
      </Grid>
    </StepContainer>
  );
}

export default StepBotSettings;
